import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "antd/dist/antd.css";
import Routes from "./config/routes/AppRoutes";
import "./App.css";
import { UserAction, DashboardAction, AuthAction } from "./store/actions";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import Loader from "./components/loader";

function App(props) {
  const [seconds, setSeconds] = useState(0);


  useEffect(() => {
    document.getElementsByTagName("title")[0].innerHTML =
      props?.storeName?.storeInfo?.rmx_company_asset?.store_name || "Main Frame";
  }, [props.storeName]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (props?.user?.length) {
      dispatch(DashboardAction.getNotificationReq());

      const interval = setInterval(() => {
        dispatch(DashboardAction.getNotificationReq());
      }, 1000 * 10);
      return () => clearInterval(interval);
    }
  }, [props.user]);
  useEffect(() => {
    const { getStoreName, subdomain } = props;
    getStoreName({ storeName: subdomain });

  }, []);
  console.log('loder==>', props.storeName)




  // Add this code in your React component
  // const IDLE_TIMEOUT = 300000; // Time in milliseconds (e.g., 1 minute)

  // useEffect(() => {
  //   let idleTimer;

  //   const resetIdleTimer = () => {
  //     clearTimeout(idleTimer);
  //     idleTimer = setTimeout(() => {
  //       // Perform logout action here
  //       // alert("doneeee")
  //       localStorage.clear()
  //       window.location.reload()
  //       // Call logout function or set a logout state
  //     }, IDLE_TIMEOUT);
  //   };

  //   const handleActivity = () => {
  //     resetIdleTimer();
  //   };

  //   window.addEventListener('mousemove', handleActivity);
  //   window.addEventListener('keydown', handleActivity);

  //   resetIdleTimer(); // Initial setup

  //   return () => {
  //     clearTimeout(idleTimer);
  //     window.removeEventListener('mousemove', handleActivity);
  //     window.removeEventListener('keydown', handleActivity);
  //   };
  // }, []);
  return (
    <>
      <div
        className="App"
        id={props.modal?.modals.length !== 0 ? "filterModal" : undefined}
      >
        {props.storeLoader ? <Loader /> : <Routes />}
      </div>
    </>
  );
}
function mapDispatchToProps(dispatch) {
  return {
    getStoreName: (data) => dispatch(AuthAction.getStoreUrlReq(data)),
  };
}
export default connect(
  (storeState) => ({
    app: storeState.App,
    modal: storeState?.Modal,
    user: storeState.AuthReducer.user,
    storeLoader: storeState.AuthReducer.storeLoader,
    storeName: storeState.AuthReducer
  }),
  mapDispatchToProps
)(App);
